import createStore from './redux/create';
import initialStore, {StoreState} from './initialStore';
import {Store} from 'redux';

export const store: Store<StoreState> = createStore(initialStore);
